import apiClient from "../../../../utils/interceptor"
import { ApiResponse, SectionLineData, CreateSectionLineParams, CreateSectionLineResponse, UpdateSectionLineParams } from "./interface";
import { API_URLS } from "../../../../constants";

// Helper function to get auth token from localStorage
const getAuthToken = (): string | null => {
    return localStorage.getItem("auth_token");
};

// Function to get section lines by section ID
export const getSectionLinesBySectionID = async (sectionId: string): Promise<ApiResponse<SectionLineData[]>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.get<ApiResponse<SectionLineData[]>>(
            `${API_URLS.SECTION_LINE.GET_SECTION_LINES}?section_id=${sectionId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching section lines:", error);
        throw error;
    }
};

// Function to create a section line
export const createSectionLine = async (
    sectionLineParams: CreateSectionLineParams
): Promise<ApiResponse<CreateSectionLineResponse>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.post<ApiResponse<CreateSectionLineResponse>>(
            API_URLS.SECTION_LINE.CREATE_SECTION_LINE,
            sectionLineParams,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error creating section line:", error);
        throw error;
    }
};

// Function to update a section line
export const updateSectionLine = async (
    sectionLineData: UpdateSectionLineParams
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.patch<ApiResponse<null>>(
            API_URLS.SECTION_LINE.UPDATE_SECTION_LINE,
            sectionLineData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating section line:", error);
        throw error;
    }
};

// Function to delete a section line
export const deleteSectionLine = async (
    sectionLineId: string
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.delete<ApiResponse<null>>(
            `${API_URLS.SECTION_LINE.DELETE_SECTION_LINE}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: { section_line_id: sectionLineId },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting section line:", error);
        throw error;
    }
};
